import Login from '@/views/public/login'
import CreateAccount from '@/views/public/create-account'
import Message from '@/views/public/message'
import PasswordRecoverByEmailOrSMS from '@/views/public/password-recover-by-email-or-sms'
import PasswordRecoverValidateTokenEmail from '@/views/public/password-recover-validate-token-email'
import PasswordRecoverValidateTokenSMS from '@/views/public/password-recover-validate-token-sms'
import PasswordRecoverRequest from '@/views/public/password-recover-request'
import AuthenticateTwoFactor from '@/views/public/authenticate-two-factor'
import RegisterNewPassword from '@/views/public/register-new-password'
import formPublic from '@/views/formPublic'
import { storage } from '@/services/storage'

var routes =  [
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Entrar',
            noscroll: true
        }
    },
    {
        path: '/criar-conta',
        name: 'createAccount',
        component: CreateAccount,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Criar Conta',
        }
    },
    {
        path: '/mensagem',
        name: 'message',
        component: Message,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Mensagem',
        }
        
    },
	{
        path: '/solicitar-alteracao',
        name: 'passwordRecoverRequest',
        component: PasswordRecoverRequest,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Solicitar alteração de senha',
        }
    },
    {
        path: '/autenticacao-dois-fatores',
        name: 'twoFactorAuthentication',
        component: AuthenticateTwoFactor,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Autenticação de dois fatores',
        }
    },
    {
        path: '/lembrar-senha-por-email-ou-sms',
        name: 'passwordRecoverByEmailOrSMS',
        component: PasswordRecoverByEmailOrSMS,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Lembrar Senha',
        }
    },
    {
        path: '/validar-token-email',
        name: 'passwordRecoverValidateTokenEmail',
        component: PasswordRecoverValidateTokenEmail,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Lembrar Senha - Validar Código - E-mail',
        }
    },
    {
        path: '/validar-token-sms',
        name: 'passwordRecoverValidateTokenSMS',
        component: PasswordRecoverValidateTokenSMS,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Lembrar Senha - Validar Código - SMS',
        }
    },
    {
        path: '/alterar-senha',
        name: 'registerNewPassword',
        component: RegisterNewPassword,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Alterar Senha',
        }
    },
    {
        path: '/form-public/:id',
        name: 'form-public',
        component: formPublic,
        props: true,
        meta: {
            title: (storage.get('client_name') || 'Facilita') + ' - Formulário publico',
        }
    },
    
]

export { routes }